import { render, staticRenderFns } from "./GeneralModal.vue?vue&type=template&id=46b825b8&scoped=true&"
import script from "./GeneralModal.vue?vue&type=script&lang=js&"
export * from "./GeneralModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b825b8",
  null
  
)

export default component.exports